import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Short-lived access cookie: on 401 refresh once (shared) and retry the original request
let refreshing = null;
const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/session"];
api.interceptors.response.use(undefined, async (error) => {
  const cfg = error?.config;
  if (error?.response?.status === 401 && cfg && !cfg._retried && !NO_REFRESH.some((p) => cfg.url?.includes(p))) {
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { setTimeout(() => { refreshing = null; }, 0); });
      await refreshing;
      return api(cfg);
    } catch { /* fall through */ }
  }
  return Promise.reject(error);
});

// Daily cap hit anywhere -> slide up the global upgrade sheet
api.interceptors.response.use(undefined, (error) => {
  const d = error?.response?.data?.detail;
  if (error?.response?.status === 402 && d && d.code === "limit_reached") {
    window.dispatchEvent(new CustomEvent("moyo:limit", { detail: d }));
  }
  return Promise.reject(error);
});

export function imgUrl(u) {
  if (!u) return null;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}
